// extracted by mini-css-extract-plugin
export default {"root":"prDuN7M8"};